import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import axios from "axios";
import ConfirmationModal from "../../shared/ConfirmationModal";
import { Container, Row, Col, Card, Button  } from "react-bootstrap";

interface Contact {
  id: string;
  name: string;
  email: string;
  mobile: string;
  address: string;
  subject: string;
  message: string;
  userid: string;
}

const ContactEdit = () => {
  const { contactid } = useParams<{ contactid: string }>();
  const [contact, setContact] = useState<Contact | null>(null);
  const [loading, setLoading] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showNoChangesModal, setShowNoChangesModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formValues, setFormValues] = useState<Contact | null>(null);
  const navigate = useNavigate();

  const headers = {
    "x-access-token": localStorage.getItem("jwttoken") || "",
  };

  const fetchContactById = async (id: string) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}contact/getcontact/${id}`;
      const response = await axios.get<Contact>(url);
      setContact(response.data);
    } catch (error) {
      console.error("Error fetching contact:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateContact = async (values: Contact) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}contact/updatecontact/${contactid}`;
      const response = await axios.put(url, values, { headers});
      return { success: true };
    } catch (error) {
      console.error("Error updating contact:", error);
      return { success: false };
    }
  };

  const handleConfirmSubmit = async () => {
    if (formValues) {
      const result = await updateContact(formValues);
      setShowConfirmModal(false);
      if (result.success) {
        setShowSuccessModal(true);
      } else {
        console.error("Error occurred during contact update");
      }
    }
  };

  const handleSubmit = (values: Contact) => {
    const hasChanges = JSON.stringify(values) !== JSON.stringify(contact);
    if (!hasChanges) {
      setShowNoChangesModal(true);
      return;
    }
    setFormValues(values);
    setShowConfirmModal(true);
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    navigate("/contactlist");
  };

  const handleModalClose = () => {
    setShowConfirmModal(false);
    setShowNoChangesModal(false);
  };

  useEffect(() => {
    if (contactid) {
      fetchContactById(contactid);
    } else {
      setLoading(false);
    }
  }, [contactid]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!contact) {
    return <div>No contact found</div>;
  }

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Edit Contact</h4>
            </Card.Header>
          <Card.Body>

      <Formik
        enableReinitialize
        initialValues={contact}
        onSubmit={(values: Contact) => handleSubmit(values)}
      >
        {() => (
          <Form>
            <Row className="mb-3">
              <Col md={6}>
              <label htmlFor="name" className="form-label">
                Name:
              </label>
              <Field name="name" type="text" className="form-control" required />
              </Col>
              <Col md={6}>
              <label htmlFor="userid" className="form-label">
                User ID:
              </label>
              <Field name="userid" type="text" className="form-control" />
            </Col>
            </Row>
            <Row className="mb-3">
            <Col md={6}>
              <label htmlFor="email" className="form-label">
                Email:
              </label>
              <Field name="email" type="email" className="form-control" required />
            </Col>
              <Col md={6}>
              <label htmlFor="mobile" className="form-label">
                Mobile:
              </label>
              <Field name="mobile" type="text" className="form-control" required />
            </Col>
            </Row>
            <Row className="mb-3">
            <Col md={12}>
            <label htmlFor="subject" className="form-label">
                Subject:
              </label>
              <Field name="subject" type="text" className="form-control" required />
              </Col>
            <Col md={12}>
              <label htmlFor="message" className="form-label">
                Message:
              </label>
              <Field name="message" type="text" as="textarea" className="form-control" required />
              </Col>
            </Row>
            <Row className="mb-3">
            </Row>

             <Row className="mt-4">
                <Col className="text-center">
                <Button type="submit" variant="success">
                  Submit
                </Button>
                <Button
                  variant="danger" className="mx-2" 
                  onClick={() => navigate("/ContactList")}
                >
                  Cancel
                </Button>
                </Col>
            </Row>
          </Form>
        )}
      </Formik>
      {/* No Changes Made Modal */}
      <ConfirmationModal
        show={showNoChangesModal}
        onHide={handleModalClose}
        modalMessage="No changes were made."
        operationType="Update"
      />

      {/* Are You Sure Modal */}
      <ConfirmationModal
        show={showConfirmModal}
        onHide={handleModalClose}
        modalMessage="Are you sure you want to make these changes?"
        operationType="Confirm"
        confirmation={handleConfirmSubmit}
      />

      {/* Success Modal */}
      <ConfirmationModal
        show={showSuccessModal}
        onHide={handleSuccessModalClose}
        modalMessage="Changes made successfully."
        operationType="Ok"
        confirmation={handleSuccessModalClose}
      />
       </Card.Body>
                </Card>
              </Col>
            </Row>
    </Container>
  );
};

export default ContactEdit;
